import { Button } from '@mantine/core';
import { AlertTriangle } from 'lucide-react';

import { Page } from '@/components/page.tsx';

import { cn } from '@/utils/style-utils.ts';

interface Props {
    message?: string;
    onRetry?: () => void;
    className?: string;
}

export const ErrorState = ({ message = 'Ein unerwarteter Fehler ist aufgetreten.', onRetry, className }: Props) => {
    return (
        <Page className={cn('flex flex-col items-center justify-center gap-6', className)}>
            <AlertTriangle className="size-12 text-red-500" />
            <div className="flex flex-col items-center gap-2 text-center">
                <h2 className="text-xl font-semibold">Etwas ist schiefgelaufen</h2>
                <p className="max-w-md text-sm text-gray-500">{message}</p>
            </div>
            {onRetry && (
                <Button variant="outline" onClick={onRetry}>
                    Erneut versuchen
                </Button>
            )}
        </Page>
    );
};
